export default __webpack_public_path__ + "static/media/world-atlas-3-lqMAX.61b4ee81.jpg";